import { Guid } from "@/Common/Models/Guid";

class InboundFaxNotes {
    public Id: Guid;
    public InboundFaxId: Guid;
    public Notes: string = "";
    public CreatedDate: Date = null;
    public CreatedByEmployeeId: string = null;
    public LastUpdatedDate: Date = null;
    public LastUpdatedByEmployeeId: string = null;
    public DeletedDate: Date = null;
    public DeletedByEmployeeId: string = null;
}
export { InboundFaxNotes };
